const StickyCta = () => {
  const days = ['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'];
  const now = new Date();
  const day = days[ now.getDay() ];
  return (
    <div className="mobile-sticky-cta">
      <a href="/contact-us" className="mobile-sticky-cta__link button">
        {day === "Saturday" || day === "Sunday" ? "Get started" : "CONTACT US"}
      </a>
    </div>
  );
};

export default StickyCta;
